import { useEffect, useRef } from 'react';
import { getJobs } from '../firebase';

export default function useJobsPolling({ onData, intervalMs = 60000, enabled = true }) {
  const fetchingRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    let intervalId;
    let abortController = new AbortController();

    const fetchJobs = async () => {
      if (document.hidden || fetchingRef.current) return;
      fetchingRef.current = true;
      try {
        const jobs = await getJobs({
          includeLatestExecution: true,
          includeSchedule: true,
          signal: abortController.signal,
        });
        if (onData) onData(jobs);
      } catch (e) {
        // Ignore errors; will retry on next tick or visibility change
      } finally {
        fetchingRef.current = false;
      }
    };

    // Unconditional first fetch (do not check document.hidden)
    const fetchNow = async () => {
      if (fetchingRef.current) return;
      fetchingRef.current = true;
      try {
        const jobs = await getJobs({
          includeLatestExecution: true,
          includeSchedule: true,
          signal: abortController.signal,
        });
        if (onData) onData(jobs);
      } catch (e) {
        // Ignore errors; will retry on next tick or visibility change
      } finally {
        fetchingRef.current = false;
      }
    };

    const onVisibility = () => {
      if (!document.hidden) fetchNow();
    };
    const onFocus = () => { fetchNow(); };

    // kick off immediately
    fetchNow();
    intervalId = setInterval(fetchJobs, intervalMs);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', onFocus);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', onFocus);
      abortController.abort();
    };
  }, [enabled, intervalMs, onData]);
}
